import { render, staticRenderFns } from "./doctorManageAdd.vue?vue&type=template&id=60ae49cc&scoped=true"
import script from "./doctorManageAdd.vue?vue&type=script&lang=js"
export * from "./doctorManageAdd.vue?vue&type=script&lang=js"
import style0 from "./doctorManageAdd.vue?vue&type=style&index=0&id=60ae49cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ae49cc",
  null
  
)

export default component.exports